import { render, staticRenderFns } from "./center_3.vue?vue&type=template&id=f56b43ba&scoped=true&"
import script from "./center_3.vue?vue&type=script&lang=js&"
export * from "./center_3.vue?vue&type=script&lang=js&"
import style0 from "./center_3.vue?vue&type=style&index=0&id=f56b43ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56b43ba",
  null
  
)

export default component.exports